export const DEFAULT_PRODUCT_STATUS = 'Published'